import React from "react";
import { Button } from "../../Button";
import { Container } from "../../Container";
import { useUtilityStyles, UtilityStyle } from "../../hooks/useUtilityStyles";
export var HeaderTitle = function (_a) {
    var title = _a.title, subtitle = _a.subtitle, children = _a.children, reference = _a.reference, status = _a.status, _b = _a.width, width = _b === void 0 ? "standard" : _b, right = _a.right;
    var classes = useUtilityStyles([
        { container: [UtilityStyle.HorizontalPaddingMedium] },
    ]);
    return (React.createElement("div", { className: "page-header" },
        React.createElement(Container, { fluid: width === "full-width", className: width === "full-width" ? classes.container : undefined },
            reference && (React.createElement("div", { className: "pull-right" },
                React.createElement(Button, { label: reference.text, onClick: reference.onClick && reference.onClick, type: "suppressed", id: reference.id }))),
            right && React.createElement("div", { className: "pull-right" }, right),
            (title || subtitle || status) && (React.createElement("div", { className: status ? "page-header--title-status" : undefined },
                title && (React.createElement("h1", null,
                    title,
                    subtitle && typeof subtitle === "string" && (React.createElement(React.Fragment, null,
                        React.createElement("br", null),
                        React.createElement("small", null, subtitle))))),
                subtitle && typeof subtitle !== "string" && (
                // Rich subtitles may contain block elements, which are not
                // valid phrasing content inside the h1/small.
                React.createElement("div", { className: "page-header--subtitle", style: { marginTop: 8 } }, subtitle)),
                status && React.createElement("div", { className: "page-header--status" }, status))),
            children)));
};
